import React, { useRef, useState } from 'react';
import { sendMembershipEmail, validateFormData } from '../utils/emailService';
import Images from '../assets/AllImages';
import { useTranslation } from 'react-i18next';
import { useToast } from '../components/Toast';

const MEMBERSHIP = () => {
  const { t } = useTranslation();
  const { success, error } = useToast();
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

 const sendEmail = async (e) => {
  e.preventDefault();
  if (isSubmitting) return;
  if (!form.current) return;

  setIsSubmitting(true);

  const fd = new FormData(form.current);
  const data = {
    federation_name: String(fd.get('federation_name') || '').trim(),
    contact_person:  String(fd.get('contact_person')  || '').trim(),
    address:         String(fd.get('address')         || '').trim(),
    phone_number:    String(fd.get('phone_number')    || '').trim(),
    user_email:      String(fd.get('user_email')      || '').trim(),
    arrival_date:    fd.get('arrival_date'),
    departure_date:  fd.get('departure_date'),
    apartments_count:String(fd.get('apartments_count')|| '').trim(),
    message:         String(fd.get('message')         || '').trim(),
  };

  // single source of truth: validator (it must enforce departure < arrival)
  const { isValid, errors } = validateFormData('membership', data);
  if (!isValid) {
    error((t('membership.fixErrors') || 'Please fix the errors:') + '\n' + errors.join('\n'));
    setIsSubmitting(false);
    return;
  }

  try {
    await sendMembershipEmail(data); // throws on failure
    success(t('membership.success') || 'Email sent successfully.');
    form.current.reset();
  } catch (err) {
    error(
      (t('membership.failurePrefix') || 'Failed to submit:') + ' ' +
      (err?.message || t('membership.failureGeneric') || 'Please try again.')
    );
    console.error('Membership form error:', err);
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <>
      <main>
        <div className="container-fluid bg-primary py-4">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h1 className="text-white fw-bold mb-4 responsive-heading">{t('membership.title')}</h1>
            </div>
            <div className="col-12 col-md-6 px-5 d-none d-sm-block text-end">
              <img src={Images.Vactor2} alt="Membership Vector" className='vector-img' />
            </div>
          </div>
        </div>
      </main>

      {/* Form Section */}
      <div className="container-fluid py-5 bg-light">
        <div className="container-fluid px-5">
          <div className="row align-items-stretch">

            {/* Form Area */}
            <div className="col-12 col-lg-6">
              <div className="text-start mb-5">
                <h3 className="text-primary fw-bold contact-heading">
                  {t('membership.formTitle')}
                </h3>
                {/* <p className="fw-normal text-dark mb-4" style={{ fontSize: '1.25rem' }}>
                  Please fill in and return it before July 17th, 2025 to the Organizing Committee
                </p> */}
              </div>

              <h4 className="text-primary fw-bold mb-4" style={{ fontSize: '1rem' }}>
                {t('membership.contactHeader')}
              </h4>

              <form ref={form} onSubmit={sendEmail}>
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.federation_name')} *</label>
                    <input
                      type="text"
                      name="federation_name"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.contact_person')} *</label>
                    <input
                      type="text"
                      name="contact_person"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.address')} *</label>
                    <input
                      type="text"
                      name="address"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.phone_number')} *</label>
                    <input
                      type="tel"
                      name="phone_number"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.user_email')} *</label>
                    <input
                      type="email"
                      name="user_email"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.arrival_date')} *</label>
                    <input
                      type="date"
                      name="arrival_date"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.departure_date')} *</label>
                    <input
                      type="date"
                      name="departure_date"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.apartments_count')} *</label>
                    <input
                      type="number"
                      name="apartments_count"
                      min="1"
                      step="1"
                      required
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-bold text-dark">{t('membership.fields.message')}</label>
                    <textarea
                      name="message"
                      rows="4"
                      className="form-control form-control-lg"
                      style={{
                        borderRadius: '6px',
                        border: '0px solid #e9ecef',
                        padding: '1rem',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                      }}
                    ></textarea>
                  </div>

                  <div className="col-12 text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg px-5 py-3 fw-bold"
                      disabled={isSubmitting}
                      style={{ 
                        borderRadius: '8px', 
                        fontSize: '1.2rem', 
                        letterSpacing: '0.5px',
                        minWidth: '200px',
                        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                        boxShadow: '0 4px 15px rgba(0, 123, 255, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          {t('membership.submitting')}
                        </>
                      ) : (
                        t('membership.submit')
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Image Section */}
            <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center">
              <img
                src={Images.Contactimg1}
                alt="Accommodation"
                className="img-fluid w-100 h-100"
                style={{ objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MEMBERSHIP;
